import {
  Box as MuiBox,
  Link as MuiLink,
  Typography as MuiTypography,
} from "@mui/material";
import { AccessDenied, useUsers } from "common";
import { useTranslation } from "react-i18next";

export const TableauReporting = () => {
  const { currentUser } = useUsers();
  const { permissions } = currentUser;
  const { t } = useTranslation();

  if (!permissions.VIEW_COMMITMENTS) {
    return <AccessDenied supportEmail={t("app.supportEmail")} />;
  }

  return (
    <MuiBox
      sx={{
        pt: 2,
      }}
    >
      <MuiTypography>
        {t("TableauReporting.mainView.text")}
        <MuiLink
          target="_blank"
          rel="noopener noreferrer"
          sx={{ textDecoration: "none" }}
          href={t("TableauReporting.mainView.url")}
        >
          {t("TableauReporting.mainView.title")}
        </MuiLink>
      </MuiTypography>
    </MuiBox>
  );
};
